import { useState, useEffect } from "react";
import ImageGallery from "react-image-gallery";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import "./shopViewModel.css";
import { Row, Col, Container } from "react-bootstrap";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useGetPropertyByIdQuery, useDeletePropertyMutation } from "../../features/property/propertyApiSlice";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
import Loader from "../Loader";
import BackArrow from "../backArrow";
import { useSelector } from "react-redux";
import ShareModel from "../Sharemodel";
import ShareOption from "../Shareoption";
import RedoIcon from "@mui/icons-material/Redo";
import { getAsset, formatCurrencyCode } from "../../helpers/helper";
import MainModal from "../ui/modal/modal";

const OwnerPropertyViewModel = ({
  update,
  deleteurl,
  setShowmodal,
}) => {
  const { id } = useParams();
  const [showshare, setShowshare] = useState(0);
  const [show, setShow] = useState(0);
  const [shows, setShows] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const handleClose = () => setShows(0);
  const navigate = useNavigate();
  
  const { data, isLoading: queryLoading, isError, error } = useGetPropertyByIdQuery(id);
  const singleitem = data?.data?.Property;
  const [deleteProperty] = useDeletePropertyMutation();
  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };

  const handleClosemodal = () => {
    setShow(0);
  };

  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };

  useEffect(() => {
    if (singleitem) {
      const thumimgs = document?.querySelectorAll(
        ".image-gallery-thumbnail-image"
      );

      thumimgs?.forEach((element) => {
        element?.setAttribute("crossorigin", "anonymous");
      });
    }
  }, [singleitem]);

  useEffect(() => {
    if (singleitem) {
      const img = document?.querySelectorAll(".image-gallery-image");

      img?.forEach((element) => {
        element?.setAttribute("crossorigin", "anonymous");
      });
    }
  }, [singleitem]);



  const validImages = Array.isArray(singleitem?.image)
    ? singleitem.image.filter(
        (img) => img && img !== "null" && img !== "undefined",
      )
    : [];
  const hasImage = validImages.length > 0;

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.removeAttribute("crossorigin");
    e.target.src = noImagePlaceholder;
  };

  const ShopModelCarousal = validImages.map((image, index) => ({
    id: index + 1,
    original: getAsset(image),
    thumbnail: getAsset(image),
    renderItem: (item) => (
      <img
        src={item.original}
        alt="item"
        onError={handleImageError}
        crossOrigin="anonymous"
        className="image-gallery-image"
      />
    ),
  }));

  const Deleteitem = () => {
    setIsloading(true);
    deleteProperty(id)
      .unwrap()
      .then((response) => {
        if (response.success) {
          SuccessNotify("Item Deleted Successfully");
          setShows(0);
          if (setShowmodal) setShowmodal(0);
          navigate(deleteurl);
        } else {
          setIsloading(false);
          FailedNotify("Failed to Delete Try Again!");
        }
      })
      .catch((e) => {
        FailedNotify("Failed to Delete Try Again!");
        setShows(0);
        setIsloading(false);
      });
  };

  if (isloading || queryLoading) {
    return <Loader heightsetting="screenHeight" />;
  }

  if (isError) {
    return (
      <Container>
        <div className="text-center mt-5">
          <h3 style={{ color: "red" }}>Error loading item details.</h3>
          <p>{error?.data?.message || "Something went wrong. Please try again later."}</p>
        </div>
      </Container>
    );
  }

  return (
    <>
      {shows === 1 && (
        <MainModal
          variant="deleteModal"
          show={!!shows}
          shows={!!shows}
          title="Item"
          handleClose={handleClose}
          animation={true}
          handledelete={Deleteitem}
          handleDelete={Deleteitem}
        />
      )}

      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        handleClosemodal={handleClosemodal}
        show={show}
        handleShowshare={handleShowshare}
        // Without a `shareurl` (or `shopid`), ShareModel falls back to just
        // the site's base URL, so the shared link never pointed at this
        // specific item. Use the current page URL, which already contains
        // this item's own `id` (this component is rendered at routes like
        // /single-property-addview/:id, /business-property-view/:id, etc).
        shareurl={window.location.href}
        shopTitle={singleitem?.subCategory || ""}
        shopDesc={singleitem?.description || ""}
        shopImage={hasImage ? validImages[0] : ""}
        // The URL above ends in this ITEM's own id, not a shop id — don't
        // let ShareModel mistake it for one and build a broken shop-share
        // redirect link instead of just sharing this page's real URL.
        disableShopAutoDetect
      />

      <Container className="owner-property-view">
        <div className="screenHeight owner-property-content">
          <div className="owner-property-posted-date">
            <p className="mb-2">
              Posted on {moment(singleitem?.duration).format("DD-MM-YYYY")}
            </p>
          </div>
          <Row className="owner-property-layout">
            <Col xs={12} lg={6} className="owner-property-gallery-column">
              <div className="owner-property-gallery">
                <div className="owner-property-mobile-back d-md-none">
                  <BackArrow />
                </div>
                {ShopModelCarousal.length > 0 ? (
                  <ImageGallery
                    showPlayButton={false}
                    showFullscreenButton={false}
                    items={ShopModelCarousal}
                  />
                ) : (
                  <div className="owner-property-no-image d-flex flex-column align-items-center justify-content-center">
                    <img
                      src={noImagePlaceholder}
                      alt="No Image Found"
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noImagePlaceholder;
                      }}
                    />
                    <p className="text-muted mt-2 mb-0">No Image Found</p>
                  </div>
                )}
              </div>
            </Col>
            <Col xs={12} lg={6} className="owner-property-details-column">
              <div className="owner-property-details bg-vilot View-Model-Shadow">
                <div className="owner-property-toolbar">
                  <div className="d-none d-md-block">
                    <BackArrow />
                  </div>
                  <button
                    className="owner-property-share text-white bg-blue border-0 font_12 rounded"
                    onClick={() => setShow(1)}
                  >
                    Share <RedoIcon className="share_icon_f" />
                  </button>
                </div>

                <div className="owner-property-info">
                  <h4 className="fw-bold owner-property-title">
                    {singleitem?.subCategory}
                  </h4>
                  <p className="fw-lighter description-font-size owner-property-description">
                    {singleitem?.description}
                  </p>

                  <div className="owner-property-price">
                    <h3 className="font-blue owner-property-price-text">
                      Price: {formatCurrencyCode(singleitem?.currency)}{" "}
                      {singleitem?.price}
                    </h3>
                  </div>

                  <div>
                    <div>
                      <p className="mb-0 fw-bold pt-1 pb-1">
                        Residential/Plot/Commercial
                      </p>
                      <p className="fw-light mb-2">{singleitem?.plottype}</p>
                      <div>
                        <p className="mb-0 fw-bold pt-1 pb-1">
                          Rent/Buy/Lease
                        </p>
                      </div>
                      <p className="fw-light mb-0">{singleitem?.saletype}</p>
                    </div>
                  </div>
                  <div className="owner-property-contact">
                    <h5 className="mb-2">Contact-Us On</h5>
                    <p className="mb-1">{singleitem?.email}</p>
                    <p className="mb-0">{singleitem?.contactnumber}</p>
                  </div>
                  <div className="owner-property-actions">
                    <button
                      className="d-flex align-items-center justify-content-center border rounded ps-3 pe-3 pt-1 pb-1 bg-red text-white"
                      onClick={() => setShows(1)}
                    >
                      <DeleteOutlineOutlinedIcon />
                      <span className="ps-1">Delete</span>
                    </button>
                    <button
                      className="d-flex align-items-center justify-content-center border rounded ps-4 pe-4 pt-1 pb-1 bg-blue text-white"
                      onClick={() => navigate(`${update}/${id}`)}
                    >
                      <CreateOutlinedIcon />
                      <span className="ps-1">Edit</span>
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default OwnerPropertyViewModel;
